import { Checkbox as MuiCheckbox, CheckboxProps, makeStyles } from '@material-ui/core';
import { primaryGreen } from 'src/data/colors';

const useStyles = makeStyles(() => ({
  checkbox: {
    '&.Mui-checked': {
      color: primaryGreen,
    },
  },
}));

export const Checkbox = ({ checked, ...props }: CheckboxProps) => {
  const classes = useStyles();
  return <MuiCheckbox className={classes.checkbox} checked={checked} {...props} />;
};
